module.exports = __webpack_public_path__ + "static/img/moon.d9bd89b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/moon.png
// module id = Xv+F
// module chunks = 1